import { request } from '../boot/request.js';

const getOrderInfo = params => {
  params = params || {};
  return request({
    url: '/paymentSuccess',
    method: 'POST',
    data: params,
  });
};

// 当支付失败的时候请求，获取再次支付信息
const reOrder = params => {
  params = params || {};
  return request({
    url: '/reOrder',
    method: 'POST',
    data: params,
  });
};
// // 弹框请求
const sellerTracking = params => {
  params = params || {};
  return request({
    url: '/tracking',
    method: 'GET',
    params,
  });
};

// 反转支付
const reversalCheck = params => {
  params = params || {};
  return request({
    url: '/reversalOvoPay',
    method: 'POST',
    data: params,
  });
};

// 检查反转支付状态
const checkReversalStatus = params => {
  params = params || {};
  return request({
    url: '/checkOvoReversalStatus',
    method: 'POST',
    data: params,
  });
};

// 完成订单
const customerOrderCompleted = params => {
  params = params || {};
  return request({
    url: '/customerOrderCompleted',
    method: 'POST',
    data: params,
  });
}

// 订单轮训接口
const checkoutStatus = params => request({
  url: '/checkoutStatus',
  method: 'GET',
  params
})

export const pullPaymentStatus = params => request({
  url: '/pullPaymentStatus',
  method: 'GET',
  params
})

export const getCancelReasonList = params => request({
  url: '/getRefundReasonTemplates',
  method: 'GET',
  params
})

export {
  // eslint-disable-next-line max-len
  getOrderInfo, reOrder, sellerTracking, reversalCheck, checkReversalStatus, customerOrderCompleted, checkoutStatus
};
